import { Component, OnDestroy, OnInit, Input, ViewChild } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { Router } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { MatDatepicker } from '@angular/material/datepicker';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import _moment from 'moment';
import { default as _rollupMoment, Moment } from 'moment';
import { FormControl } from '@angular/forms';
const moment = _rollupMoment || _moment;
import 'rxjs';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import { DBService } from '../../service';
import { DownLoadService } from '../download';
import { AuthService } from '../../service';
import { User } from '../../model/types';
import { AnalysisKey, AuditTrail, AuditTrailData } from '../../model/analysis-details.model';
import { DropDownService } from '../../service/drop-down.service';
import { AppLoaderService } from '../../service/app-loader/app-loader.service'

export const MY_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MM/DD/YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    selector: 'app-audit',
    templateUrl: './audit.component.html',
    styleUrls: ['./audit.component.scss'],
    providers: [{
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
    ],
    standalone: false
})
export class AuditComponent implements OnInit, OnDestroy {
    @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
    @ViewChild(MatSort, { static: false }) sort: MatSort;
    dataSource: MatTableDataSource<AuditTrail>;
    tableColumns: string[] = ['projectCode', 'fileName', 'analysisDate', 'status', 'userId', 'full_name', 'access'];
    pageTitle = 'Audit Trail';
    signedInUser: any;
    previousAnalysisKeys: AuditTrail[] = [];
    pageLoaded = false;
    date = new FormControl(moment());
    startDate;
    endDate;
    role;
    username: string;
    email: string;
    users: any[] = [];
    loading = false;
    illegalUser: boolean;
    auditFlag: boolean = false;
    maxYear;
    displayErrorMessage: boolean = false;
    isLoading: boolean = false;
    errorMessage: string = ''

    @ViewChild('datePicker') public dp;
    @Input() auditSearch: AuditTrail[] = [];


    constructor(private _sharedService: SharedService,
        private authService: AuthService,
        private router: Router,
        private dbService: DBService,
        private dropDownService: DropDownService,
        private downloadService: DownLoadService,
        private loader: AppLoaderService,) {
        this.dataSource = new MatTableDataSource(this.previousAnalysisKeys);
        this.dbService.auditSearch.subscribe(
            (data: AuditTrail[]) => {
                this.previousAnalysisKeys = data;
                this.dataSource.data = data;
            }
        )
        this._sharedService.emitChange(this.pageTitle);
    }

    openDialog() {
        this.loader.open();
    }

    getUrl(analysisType: string) {
        if (analysisType === 'RSG') {
            return '/default-layout/analysis-details';
        } else if (analysisType === 'SMR' || analysisType === 'LMR' || analysisType === 'ADA') {
            return '/default-layout/molecule-analysis';
        } else {
            return '/default-layout/notfound';
        }
    }

    applyFilter(filterValue: string) {
        this.dataSource.filter = filterValue.trim().toLowerCase();
    }


    ngOnInit(): void {
        this.authService.getCurrentUser((err, user: User) => {
            this.signedInUser = user;
            if (!this.signedInUser || !this.signedInUser.signedIn) {
                this.router.navigate(['/extra-layout/signin']);
                return;
            } else {
                this.role = sessionStorage.getItem('access');
                if (this.role == 'GA' || this.role == 'QA' || this.role == 'SU') {
                    this.illegalUser = false;
                    this.getAuthLoginData(this.signedInUser.username, this.startDate, this.endDate)

                } else {
                    this.illegalUser = true;
                }
            }
        });

        //         this.dbService.getAuditTrail(this.signedInUser.username).subscribe(
        //             (data: AuditTrail[]) => {
        //                 this.previousAnalysisKeys = data;
        //                 this.pageLoaded = true;
        //                 // if(this.pageLoaded==true){
        //                 //     this.closeDialog()
        //                 //   }
        //             }
        //         );


    }

    getAuthLoginData(loginuserId, LogstartDate, LogendDate) {
         this.pageLoaded = true;
        this.errorMessage = '';
        this.isLoading = true;
        this.dbService.getAuditTrail(loginuserId, LogstartDate, LogendDate)
            .subscribe({
                next: (data: AuditTrailData) => {
                    this.previousAnalysisKeys = data.data;
                    this.dataSource = new MatTableDataSource(this.previousAnalysisKeys);
                    this.pageLoaded = false;
                },
                error: (err) => {
                    this.pageLoaded = false;
                    this.displayErrorMessage = true;
                    switch (err.status) {
                        case 400:
                            this.errorMessage = "Bad Request. Please verify the input values.";
                            break;
                        case 401:
                            this.errorMessage = "Unauthorized. Please login again.";
                            break;
                        case 403:
                            this.errorMessage = "Access denied. You do not have permission to perform this action.";
                            break;
                        case 404:
                            this.errorMessage = "No data found for the given criteria.";
                            break;
                        case 500:
                            this.errorMessage = "Server error. Please try again later.";
                            break;
                        case 502:
                            this.errorMessage = "Bad Gateway. The server is temporarily unavailable.";
                            break;
                        case 503:
                            this.errorMessage = "Service Unavailable. Please try again later.";
                            break;
                        case 504:
                            this.errorMessage = "Gateway Timeout. Server took too long to respond.";
                            break;
                        default:
                            this.errorMessage = "Unexpected error occurred. Please try again.";
                    }
                    console.error('Error fetching auth logs:', err);
                }
            });
    }

    // closeDialog() {
    //     this.loader.close();
    // }

    selectedDates(dateRangeStart, dateRangeEnd) {
        this.displayErrorMessage = false;
        this.errorMessage = '';
        this.startDate = dateRangeStart.value;
        this.endDate = dateRangeEnd.value;
        this.previousAnalysisKeys = []
        this.getAuthLoginData(this.signedInUser.username, this.startDate, this.endDate)
    }

    openPDF() {
        const DATA: any = document.getElementById('reportData');
        html2canvas(DATA).then((canvas) => {
            const fileWidth = 208;
            const fileHeight = (canvas.height * fileWidth) / canvas.width;
            const FILEURI = canvas.toDataURL('image/png');
            const PDF = new jsPDF('p', 'mm', 'a4');
            const position = 0;
            PDF.addImage(FILEURI, 'PNG', 0, position, fileWidth, fileHeight);
            PDF.save('Audit-Report.pdf');
        });
    }


    ngOnDestroy(): void {
    }





}
